import React, { useContext, useEffect, useMemo, useState } from "react";
import { withTranslation } from "react-i18next";
import { BsFillCircleFill } from "react-icons/bs";
import { FcFinePrint } from "react-icons/fc";
import { useNavigate } from "react-router-dom";
import { ScaleLoader } from "react-spinners";
import { LoaderContext, RegulationContext } from "../../../App";
import useHasPermission from "../../../core/hooks/useHasPermission";
import AnomalyService from "../../../core/service/AnomalyService";
import { ANOMALY_SEVERITY_HOME_ITEMS } from "../../../core/constants/anomalySeverity";
import { resolveAnomalySummaryHomePeriod } from "../AnomalyDetection/anomalyDateUtils";
import { resolveAnomalyRegulationId } from "../AnomalyDetection/anomalyRegulationUtils";
import "./AnomalySummaryHome.scss";
import "./HomePage.scss";

const AnomalySummaryHome = ({ t, periodParams, displayYear }) => {
  const { setLoaderDisplay } = useContext(LoaderContext);
  const { glbRegulation } = useContext(RegulationContext);
  const navigate = useNavigate();
  const { hasDMPeriodicViewPermission, hasDMOneTimeViewPermission } = useHasPermission();
  const [summary, setSummary] = useState(null);
  const [hasLoaded, setHasLoaded] = useState(false);

  const glbRegulationId = resolveAnomalyRegulationId(glbRegulation);
  const canViewAnomaly = hasDMPeriodicViewPermission() || hasDMOneTimeViewPermission();

  const effectivePeriod = useMemo(
    () => resolveAnomalySummaryHomePeriod(periodParams?.periodStart, periodParams?.periodEnd),
    [periodParams?.periodStart, periodParams?.periodEnd]
  );

  useEffect(() => {
    if (
      !canViewAnomaly
      || !glbRegulationId
      || !effectivePeriod
      || effectivePeriod.isEntirelyFuture
    ) {
      setSummary(null);
      setHasLoaded(Boolean(canViewAnomaly && glbRegulationId && effectivePeriod));
      return;
    }

    setLoaderDisplay(true);
    AnomalyService.getSummary({
      regulationId: glbRegulationId,
      periodFrom: effectivePeriod.periodFrom,
      periodTo: effectivePeriod.periodTo,
    })
      .then((res) => {
        if (res.status === 200) {
          setSummary(res.data || null);
        }
      })
      .catch(() => {
        setSummary(null);
      })
      .finally(() => {
        setLoaderDisplay(false);
        setHasLoaded(true);
      });
  }, [glbRegulationId, effectivePeriod, canViewAnomaly, setLoaderDisplay]);

  const openBySeverity = summary?.openBySeverity || {};
  const totalOpen = summary?.totalOpen ?? 0;
  const apiPeriodFrom = effectivePeriod?.periodFrom;
  const apiPeriodTo = effectivePeriod?.periodTo;
  const showFutureCapNotice = Boolean(effectivePeriod?.isCapped);

  const gotoAnomalyDashboard = (e, severity) => {
    e?.preventDefault();
    if (!apiPeriodFrom || !apiPeriodTo || effectivePeriod?.isEntirelyFuture) return;
    navigate("../anomalies/dashboard", {
      state: {
        regulationId: glbRegulationId,
        periodFrom: apiPeriodFrom,
        periodTo: apiPeriodTo,
        status: "OPEN",
        ...(severity ? { severity } : {}),
      },
    });
  };

  if (!canViewAnomaly) {
    return null;
  }

  const renderEmptyState = () => (
    <div className="Nodatafound_box">
      <h6><FcFinePrint className="me-2" />{t("Nodatafound.label")}</h6>
    </div>
  );

  return (
    // <div className="HomeCard mb-3 anomaly-summary-home">
    //   <div className="HomeCardhead">
    //     <div className="HomeCardhead_in">
    //       <h5>
    //         {t("AnomalyDetection.label")}
    //         {displayYear && (
    //           <span className="ms-2">
    //             <small>({displayYear})</small>
    //           </span>
    //         )}
    //       </h5>
    //     </div>
    //     {hasLoaded && summary && (
    //       <div className="Reportablock_event">
    //         <ul>
    //           {ANOMALY_SEVERITY_HOME_ITEMS.map(({ key, className, labelKey }) => {
    //             const count = openBySeverity[key] ?? 0;
    //             return (
    //               <li
    //                 key={key}
    //                 className={count > 0 ? "cursor" : ""}
    //                 onClick={(e) => count > 0 && gotoAnomalyDashboard(e, key)}
    //                 onKeyDown={(e) => {
    //                   if (count > 0 && (e.key === "Enter" || e.key === " ")) {
    //                     e.preventDefault();
    //                     gotoAnomalyDashboard(e, key);
    //                   }
    //                 }}
    //                 role={count > 0 ? "button" : undefined}
    //                 tabIndex={count > 0 ? 0 : undefined}
    //               >
    //                 <BsFillCircleFill className={className} />
    //                 {count} {t(labelKey)}
    //               </li>
    //             );
    //           })}
    //         </ul>
    //       </div>
    //     )}
    //   </div>

    //   {showFutureCapNotice && (
    //     <p className="anomaly-summary-cap-notice">
    //       {t("HomePage.anomalySummary.futureDatesCapped.label", {
    //         from: effectivePeriod.cappedFromDisplay,
    //         date: effectivePeriod.cappedThroughDisplay,
    //       })}
    //     </p>
    //   )}

    //   <div className="HomeCardBody">
    //     {!hasLoaded ? (
    //       <div className="anomaly-summary-loading">
    //         <ScaleLoader color="#3b82f6" height={20} />
    //       </div>
    //     ) : !summary ? (
    //       renderEmptyState()
    //     ) : (
    //       <div className="anomaly-summary-home-body">
    //         <button
    //           type="button"
    //           className="anomaly-summary-total"
    //           onClick={(e) => gotoAnomalyDashboard(e)}
    //           disabled={totalOpen === 0}
    //         >
    //           <span className="anomaly-summary-total-value">{totalOpen}</span>
    //           <span className="anomaly-summary-total-label">
    //             {t("AnomalyDetection.totalOpen.label")}
    //           </span>
    //         </button>
    //         <p className="anomaly-summary-hint">
    //           {totalOpen > 0
    //             ? t("HomePage.anomalySummary.hint.label")
    //             : t("HomePage.anomalySummary.noAnomalies.label")}
    //         </p>
    //       </div>
    //     )}
    //   </div>

    //   <div className="HomeCardFooter">
    //     {t("ForMoreDetails.label")}{" "}
    //     <a href="#" onClick={(e) => gotoAnomalyDashboard(e)}>
    //       {t("HomePage.goToAnomalyDashboard.label")}
    //     </a>
    //   </div>
    // </div>
    <div></div>
  );
};

export default withTranslation()(AnomalySummaryHome);
